import BaseModel from "./BaseModel";
import CommentThread from "./CommentThread";

class VesselCommentThread extends BaseModel {
	constructor(data) {
		super({}, VesselCommentThread.defaults);
		this.data = data;

		this._thread = new CommentThread(data.thread);
	}

	get spireId() {
		return this.get("spire_id");
	}

	get thread() {
		return this._thread;
	}

	get imo() {
		return this.get("imo");
	}

	get mmsi() {
		return this.get("mmsi");
	}

	get name() {
		return this.get("name");
	}
}
VesselCommentThread.defaults = { // Defaults
	spire_id: "",
	imo: 0,
	mmsi: 0,
	name: "",
	thread: null
};

VesselCommentThread.helpers = {
	processList: (vcrs) => {
		const threads = vcrs;
		const detailsBySpireId = {};
		const threadBySpireId = {};
		for (let i = 0; i < threads.length; i++) {
			const vesselCommentThread = new VesselCommentThread(threads[i]);
			const spireId = vesselCommentThread.spireId;

			detailsBySpireId[spireId] = vesselCommentThread;

			if (typeof threadBySpireId[spireId] === "undefined") {
				threadBySpireId[spireId] = [];
			}
			threadBySpireId[spireId].push(vesselCommentThread.thread);
		}
		return {
			threadBySpireId: threadBySpireId,
			detailsBySpireId: detailsBySpireId
		};
	}
};

export default VesselCommentThread;
